export default {
  // Application title
  'application-name': 'mySGbuilding',
  // Internal/unknown error
  internalError: "Something's wrong.",
  internalErrorMessage: "We're unable to complete your request at the moment.",
  internalErrorContact: 'Contact us',
  internalErrorTryAgain: 'Try Again',
  // Page not found
  notFound: 'Page not found.',
  notFoundMessage: "Sorry, we couldn't find this page",
  notFoundContact: 'Contact us',
  notFoundGoBack: 'Go back',
  close: 'Close',
  cancel: 'Cancel',
  confirm: 'Confirm',
  firstName: 'First name',
  lastName: 'Last name',
  days: {
    MONDAY: 'Monday',
    TUESDAY: 'Tuesday',
    WEDNESDAY: 'Wednesday',
    THURSDAY: 'Thursday',
    FRIDAY: 'Friday',
    SATURDAY: 'Saturday',
    SUNDAY: 'Sunday',
  },
  // Home page
  home: {
    'welcome-title': 'Welcome on MyBuilding',
    'country-dropdown': 'Country',
    'site-dropdown': 'Site',
    'building-dropdown': 'Building',
    'dropdown-select': 'Select',
    'dropdown-goToServices': 'Access the building',
  },
  qrCode: {
    help: 'Find the application in its mobile version by scanning the QR code.',
  },
  header: {
    selectSiteCancel: 'Cancel',
    changeSiteTitle: 'Change location',
    selectSiteTitle: 'Select your location',
    home: 'Home',
    changeSite: 'Change site',
  },
  smartBuilding: {
    favourites: 'My favourites',
    location: 'Select building',
    workspaces: 'Workspaces',
    selectBuilding: 'Select a building',
    choice: 'Site choice',
    selectBuildingHome:
      'Select a site (list on the left) then a building (list on the right)',
    selectBuildingDomotic: 'Select a building and floor',
    building: 'Buildings',
    floor: 'Floor',
    room: 'Room or location',
    noFavourites: 'No favourites',
    addFavourites: 'Add to favourites',
    deleteFavourites: 'Remove from favourites',
    selectSite: 'Select your location using the menu on the left',
    remoteControl: {
      temperature: 'Temperature',
      degree: 'degree',
      offset: 'Offset : ',
      lighting: 'Lighting',
      blinds: 'Blinds',
      blind: 'Blind',
      group: 'Group',
      all: 'All',
    },
  },
  reservation: {
    workstationReservation: 'Book a workstation',
    ReserveNextTo: 'Book next to',
    myShares: 'My Shares',
    bookNextTo: 'Book next to',
    MyReservation: 'My reservations',
    modify: 'Modify',
    viewOnMap: 'View on map',
    cancelBooking: 'Cancel my reservation',
    modifyModalTitle: 'Which event do you want to edit?',
    modifyModalDescription:
      'You can modify this event only or this event and all the following ones',
    modifyModalSerie: 'The serie',
    modifyModalOccurrence: 'The occurrence',
    deskNumber: 'Desk N°{number}',
    tabs: {
      date: 'Date',
      searchCollaborator: 'Search an employee',
      collaborateurShareWitYou:
        'Collaborators who share their reservations with you',
      myShares: 'My shares',
      sharesReceived: 'Sharing received',
      myReservations: 'My workstation reservations',
      building: 'Building',
      workstation: 'Bureau',
      duration: 'Duration',
      recurrence: 'Recurrence',
      days: 'Days',
      actions: 'Actions',
      search: 'Search',
      service: 'Service',
      thisWeek: 'This week',
      weeks: 'For {weeks} weeks',
      book: 'Book',
    },
    confirmCancelling: 'Do you want to cancel this reservation ?',
    success: {
      title: 'Confirmation of your reservation',
      description: 'Your reservation has been successfully completed',
      modified: 'Your reservation has been modified with success',
      bookedNear:
        'Your reservation next to {name} has been successfully completed',
      sharingTitle: 'Confirmation of your sharing',
      sharingDescription:
        'Sharing your reservations with {name} has been successfully added',
    },
    delete: {
      title: 'Confirm deletion',
      sharingDescription:
        'Are you sure you want to remove this collaborator from your shares?',
    },
    error: {
      title: 'Error during your reservation',
      description: 'You have already booked for this day',
    },
    timeSlots: {
      ALL_DAY: 'All day',
      MORNING: 'Morning',
      AFTERNOON: 'Afternoon',
      INDIFFERENT: 'Indifferent',
    },
    recurrence: {
      '1': 'One week',
      '2': 'Two weeks',
      '3': 'Three weeks',
      '4': 'Four weeks',
    },
    chooseOnMap: 'Please choose on the map, the desired location',
    nextTo: {
      sharingCollaborators: 'Employees who share their bookings with you',
      nbBookingToday: '{nb} booking today',
    },
  },
  availableDesks: {
    leftPartTitle: 'Buildings',
    rightPartTitle: 'Floors -',
    squareFree: 'Free',
    squareMedium: 'Medium',
    squareFull: 'Full',
    availablePlace: 'available places on',
    floors: 'Floors',
  },
  servicesTitles: {
    domotique: 'Smart building',
    bureauxDispo: 'Available desks',
    laVallee: 'La Vallée',
    activateBooking: 'Office reservation',
  },
  servicesDescription: {
    domotique: 'Manage temperature, blinds and lights of your workspace.',
    bureauxDispo: 'Find and check workspace availability',
    laVallee: 'Visualize La Vallée spaces affluence and general information',
    reservation: 'Reserve a workstation for one-time or regularly.',
  },
  servicesImgAltName: {
    domotique: 'Smartbuilding logo',
    bureauxDispo: 'Available desks logo',
    laVallee: 'La Vallee logo',
    reservation: 'Reservation logo',
  },
  input: {
    select: {
      selectAll: 'Select all',
      selectAllSites: 'All sites',
      noResult: 'No result',
    },
  },
  footer: {
    siteMap: 'Site map',
    Accessibility: 'Non-comforming accessibility ',
    Legal: 'Legal information',
    ContactPhone: 'Contact SAU mySGbuilding by phone:',
    Phone: '73000 (+33 1 56 373 000), option 4',
    ContactEmail: 'Contact SAU mySGbuilding by email:',
    Email: 'sau-mybuilding.par@socgen.com',
    cookies: 'Cookies',
  },
  // Getting started page
  'get-started': {
    title: 'Getting started with the React Whiteapp.',
    description:
      "If you see this screen, it means you have successfully retrieved <a href='https://apps.bsc.aws.societegenerale.com/gitlab/dex/frontend/react-whiteapp/'> React Whiteapp </a>. So,what is included in this application ?",
    note:
      'Note that the Whiteapp is periodically upgraded to the latest dependencies. Try to keep your application green (try to run <code>yarn upgrade --latest</code> often enough).',
    'issue-title':
      'You encounter an issue with this Whiteapp? You have some comments about it?',
    'issue-button': 'Create a support ticket',
    contribute:
      "In case you want to enhance or fix this Whiteapp, you can create a Merge Request on the <a href='https://apps.bsc.aws.societegenerale.com/gitlab/dex/frontend/react-whiteapp'>DEX Gitlab</a>.",
    getStartedIncluded: {
      'get-started-choice-1':
        "<a href='https://sgithub.fr.world.socgen/pages/sgbootstrap/sg-bootstrap-v4/master/demo/'>SG Bootstrap v4</a>: Official Design System (for ITEC &amp; BSC) based on <a href='https://getbootstrap.com/docs/4.3/getting-started/introduction/'>Bootstrap v4</a>",
      'get-started-choice-2':
        "<a href='https://material.io/tools/icons/?style=baseline'>Material icons</a>",
      'get-started-choice-3':
        "<a href='https://reactstrap.github.io/'>Reactstrap</a>: React implementation of bootstrap basic components",
      'get-started-choice-4':
        "Structural <a href='https://sgithub.fr.world.socgen/DT-Widgets/sgwt-widgets'>SGWidgets</a> : <code>sgwt-account-center</code> &amp; <code>sgwt-mini-footer</code>",
      'get-started-choice-5':
        "<a href='https://developer.sgmarkets.com/resources/sgconnect/toc.html'>SG Connect</a> authentication thanks to <code>@sgwt/connect-core</code> &amp; <code>sgwt-connect</code> widget",
      'get-started-choice-6':
        "<a href='https://developer.sgmarkets.com/resources/sgmonitoring/web-analytics/web-analytics-main.html'>Matomo/Piwik</a> connector: a web analytics solution",
      'get-started-choice-7':
        "<a href='https://reacttraining.com/react-router/'>React router</a> React",
      'get-started-choice-8':
        "<a href='https://github.com/formatjs/react-intl'>React intl</a>: This library provides React components and an API to format dates, numbers, and strings, including pluralization and handling translations.",
      'get-started-choice-9':
        "<a href='https://easy-peasy.now.sh/'>Easy-peasy</a>: It's an react application state management based on Redux but without the boilerplate",
      'get-started-choice-10':
        "<a href=''>Openshift</a> support: Environment variables are externalized inside an <code>env.js</code> for manage differents values between HOMOL &amp; PROD environments despite <code>promote</code> mode",
      'get-started-choice-11':
        "<a href='https://docs.gitlab.com/ee/ci/'>Gitlab-ci.yml</a> template if you choose to host your projet on <a href='https://apps.bsc.aws.societegenerale.com/gitlab/'>Gitlab</a> platform",
    },
  },
  maps: {
    globalView: 'Neighborhood view',
    domotic: 'Domotic',
    itinerary: 'Itinerary',
    fromThisPoint: 'Begin the itinerary here',
    toThisPoint: 'Finish the itinerary here',
    information: 'Information !',
    itineraryDescription:
      'You can delete your choice or choose another place directly on the map',
    startingPoint: 'Starting point :',
    endingPoint: 'Arrival place :',
    delete: 'Delete',
    previous: 'Previous',
    next: 'Next',
    steps: 'Step {currentStep} of {allSteps}',
    direction: 'Itinerary from {start} to {end}',
    selectBuilding: 'Select building - floor',
    spaceName: 'Space {space}',
    building: 'Building',
    floor: 'Floor',
    availability: 'Availability',
    available: 'Available',
    temporarilyAvailable: 'Already occupied today',
    unavailable: 'Occupied',
    statusUnknown: 'Sensor status unavailable',
    fixedDesk: 'Assigned desk'
  },
  cookies: {
    title: 'About Cookies',
    close: 'Decline and close',
    description:
      'Certain features of this site may use cookies to improve your browsing experience, for example being able to find your favourites.',
    personalize: 'Personalize',
    accept: 'Accept',
    preferences: 'Preferences related to cookies',
    necessary: 'Strictly Necessary Cookies',
    functionality: 'Functionality cookies',
    save: 'Saves preferences',
    acceptAll: 'Accept all',
    smartBuildings: {
      modalTitle: 'Feature unavailable',
      modalDescription:
        'You must accept functionality cookies to be able to add favorites',
    },
  },
  showFloorMap: 'Open the map',
  isLoading: 'Loading...'
};
